import { render, staticRenderFns } from "./pverify-get-benefits.vue?vue&type=template&id=53564653&scoped=true"
import script from "./pverify-get-benefits.vue?vue&type=script&lang=js"
export * from "./pverify-get-benefits.vue?vue&type=script&lang=js"
import style0 from "./pverify-get-benefits.vue?vue&type=style&index=0&id=53564653&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53564653",
  null
  
)

export default component.exports